export class HelpDeskInfoModel {
	email: string;
	name: string;
	phone: number;
	relation: string;
}
